import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import headersData from "../data";
import { useState } from "react";
import OnlinePaymentModal from "../../Pagos/components/OnlinePaymentModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { useDispatch } from "react-redux";
import { resetContract } from "../../../reducers/debtReducer";

const useStyles = makeStyles((theme) => ({
  navbar: {
    cursor: 'Pointer',
    '&:hover': {
      borderBottom: '2px solid'
    },
    '&:focus': {
      outline: 'none',
    },
    '&:disabled': {
      cursor: 'default',
      opacity: 0.5,
      borderBottom: 'none', 
    },
    '&:disabled:hover': {
      borderBottom: 'none', 
    },
  }
}));

const NavbarButtons = ({ isLogged, history }) => {  
  const { navbar } = useStyles();
  const [openOnlinePaymentModal, setOpenOnlinePaymentModal] = useState(false);
  const currentUrl = window.location.pathname;
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUrl === "/"){
      localStorage.removeItem("OnlinePaymentModalView")
    }
  }, [currentUrl])

  const handleClickOnlinePayment = () => {
    setOpenOnlinePaymentModal(true);
  };

  const handleCloseModal = () => {
    setOpenOnlinePaymentModal(false);
  }

  const handleSuccessModal = () => {
    setOpenOnlinePaymentModal(false);

    history.push("/pagos");
  };

  return (
    <>
      {headersData.map(({ label, href }) => {
        if (label === "PAGO ONLINE") {
          
          const isDisabled = currentUrl === "/pagos" && !isLogged;

          const handlePagoOnlineClick = () => {
            if (isLogged) {
              history.push("/contratos");   
            } else {
              sessionStorage.removeItem('contractSelected');
              dispatch(resetContract());
              setOpenOnlinePaymentModal(true); 
            }
          };

          return (
            <button
              key={label}
              className={navbar}
              color="inherit"
              onClick={handlePagoOnlineClick}
              disabled={isDisabled} 
              style={{
                opacity: isDisabled ? 0.5 : 1, 
                cursor: isDisabled ? "default" : "pointer",
                textDecoration: isDisabled ? "none" : "inherit",
              }} >
              {label}
            </button>
          );
        }

        return (
          <NavLink exact to={href} key={label}>
            <button color="inherit" className={navbar}>
              {label}
            </button>
          </NavLink>
        );
      })}
      <OnlinePaymentModal open={openOnlinePaymentModal} close={handleCloseModal} success={handleSuccessModal} /> 
    </>
  )
}

export default NavbarButtons;